import type { TestCase } from "../data/lessons";

export type PythonResult = {
  passed: boolean;
  output: string;
  error?: string;
  tests: { label: string; passed: boolean; actual: string; expected: string }[];
};

let worker: Worker | null = null;
let sequence = 0;
const pending = new Map<
  number,
  { resolve: (value: PythonResult) => void; reject: (reason: Error) => void; timeout: number }
>();

function resetWorker() {
  worker?.terminate();
  worker = null;
  for (const job of pending.values()) {
    window.clearTimeout(job.timeout);
    job.reject(new Error("De Python-runner is opnieuw gestart."));
  }
  pending.clear();
}

function getWorker() {
  if (worker) return worker;
  worker = new Worker("/python-worker.mjs", { type: "module" });
  worker.onmessage = (event) => {
    const job = pending.get(event.data.id);
    if (!job) return;
    window.clearTimeout(job.timeout);
    pending.delete(event.data.id);
    if (event.data.ok) job.resolve(event.data.result as PythonResult);
    else job.reject(new Error(event.data.error));
  };
  worker.onerror = () => resetWorker();
  return worker;
}

export function runPython(code: string, tests: TestCase[]) {
  const id = ++sequence;
  return new Promise<PythonResult>((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      resetWorker();
      reject(new Error("Je code deed er te lang over. Controleer of je geen oneindige loop hebt."));
    }, 30_000);
    pending.set(id, { resolve, reject, timeout });
    getWorker().postMessage({ id, code, tests });
  });
}
